/**
 * The browser smoke's MatchSetup recipe — shared by the page (?autoplay&setup, which
 * starts it with Game.startFromSetup) and scripts/browserSmoke.ts (which auto-resolves
 * the same setup with runBattle and compares the two turn traces). No DOM imports.
 */
import type { GameMode, TurnFlow } from '../types';
import type { MatchSetup } from '../match/setup';
import { duelMatchSetup, type DuelSetup } from '../ai/actionDuel';

/** The smoke's setup (shared with the node side of the comparison). */
export function smokeSetup(o: { seed: string; mode: GameMode; flow: TurnFlow; turns: number; clock?: 'action'; seats?: boolean }): MatchSetup {
  return {
    // R2: emplacements a short walk from each team, and bots that take the seats (watch must equal auto-resolve)
    ...(o.seats ? { emplacementsPerTeam: 2, botTuningByTeam: [{ mounting: { takeSeats: true } }, { mounting: { takeSeats: true } }] } : {}),
    seed: o.seed, mode: o.mode, turnFlow: o.flow, turnLimit: o.turns, maxRounds: 40,
    teams: 2, unitsPerTeam: 2, planets: 4, difficulty: 'medium', hazardDensity: 'some',
    // Phase 59.5: the same setup fought in real time (90 s on the clock); 390: on one megaplanet (four mixed worlds gathered onto one before)
    ...(o.clock === 'action' ? { clock: 'action' as const, actionTimeLimit: 90, planets: 1 } : {}),
  };
}


/**
 * Phase 59.3: the action duel the page plays at `?action` (and `?action&autoplay`, which the
 * smoke compares with runDuel in Node by final digest). Time limit in seconds.
 */
export function actionDuelSetup(o: { seed: string; units: number; unitsByTeam?: number[]; difficulty: string[]; timeLimit: number; scale?: 'human' | 'classic' }): DuelSetup {
  return duelMatchSetup({ seed: o.seed, teams: 2, unitsPerTeam: o.units, ...(o.unitsByTeam ? { unitsByTeam: o.unitsByTeam } : {}), difficulty: o.difficulty, timeLimit: o.timeLimit, ...(o.scale === 'human' ? { scale: 'human' } : {}) }) as DuelSetup;   // (390: the scale picks the duel's world)
}
